export default {
  bolsaComerciales: {
    menuItem: "Bolsa de comerciales",
    pageTitle: "Bolsa de comerciales",
    dashboardMenu: "Dashboard",
    settingsMenu: "Configuración",
    settingsTitle: "Configuración",
    settingsAdminOnly:
      "Solo el administrador del sistema puede gestionar estos roles.",
    walletsTab: "Carteras",
    commercialsTab: "Comerciales",
    historyTab: "Histórico",
    hiddenTab: "Ocultados",
    hideSelected: "Hide",
    unhideSelected: "Unhide",
    noHiddenMovements: "No hay movimientos ocultos.",
    hideRequiresShipping: "Solo se pueden ocultar movimientos con shipping.",
    hideDone: "Movimientos ocultados",
    unhideDone: "Movimientos restaurados",
    myWalletTab: "Mi cartera",
    commercialsConfigTitle: "Usuarios comerciales",
    initialBalance: "Saldo inicial",
    currentBalance: "Saldo actual",
    balanceAfter: "Saldo posterior",
    movements: "Movimientos",
    inject: "Inyectar",
    injectTitle: "Inyectar saldo USD",
    myWallet: "Mi cartera",
    myWalletIfCommercial: "Mi cartera (si está configurada)",
    noWallets: "Aún no hay carteras configuradas.",
    noUsers: "No hay usuarios disponibles.",
    noWalletForUser: "No tenés una cartera comercial activa.",
    noMovements: "Sin movimientos.",
    noHistory: "No hay movimientos de operaciones cerradas.",
    accessDenied: "No tenés acceso a este módulo.",
    loadError: "No se pudo cargar la bolsa de comerciales.",
    invalidAmount: "Ingresá un monto válido mayor a cero.",
    searchUsers: "Buscar usuario…",
    historySearchPlaceholder: "Buscar por concepto, contacto o shipping…",
    historyApply: "Buscar",
    historyCommercialFilter: "Comercial",
    historyAllCommercials: "Todos los comerciales",
    historyPage: "Página",
    historyOf: "de",
    bolsaRole: "Rol",
    roleNone: "Sin rol",
    roleManager: "Gerente de bolsa",
    roleViewer: "Consulta",
    openProformNewTab: "Abrir proforma en nueva pestaña",
    selectedColumns: "{count} columnas seleccionadas",
    columnTt: "TT",
    columnShipper: "Shipper",
    columnOperationalInCharge: "Operativo a cargo",
    customizeDisplay: "Personalizar columnas",
    details: "Detalle",
    invoices: "Factura",
    bankPaymentDate: "Fecha pago (banco)",
    etaFrom: "ETA desde",
    etaTo: "ETA hasta",
    etaSortDefault: "Orden por fecha de movimiento",
    etaSortNearest: "ETA más cercana primero",
    etaSortFarthest: "ETA más lejana primero",
    amountTotal: "Total Amount",
    viewAmountBreakdown: "Ver composición del total",
    amountBreakdown: "Total",
    appliedTotal: "Total Applied",
    viewAppliedBreakdown: "Ver composición del total Applied",
    subtotalColumn: "Subtotal",
    compositionAdds: "Suma",
    compositionSubtracts: "Resta",
    subtotalsByExpense: "Por expense",
    subtotalsByType: "Subtotales por tipo",
    subtotalsByShipping: "Subtotales por shipping",
    movementCount: "{count} movimientos",
    clientCommercialTooltip: "Comercial del cliente",
    supplierCommercialTooltip: "Comercial del proveedor",
    bothCommercialTooltip: "Comercial del cliente y del proveedor",
    movementType: {
      initial: "Saldo inicial",
      adjustment: "Inyección admin",
      payment: "Pago",
      collect: "Cobro",
      invoice: "Factura",
      invoiceClient: "Factura cliente",
      invoiceSupplier: "Factura proveedor",
      expense: "Gasto de embarque",
      nota_comercial: "Nota comercial",
      nota_comercial_debit: "Nota de débito comercial",
      reversal: "Reversión",
    },
  },
};
